import {ErrorMessage} from 'formik';
import makeStyles from '@mui/styles/makeStyles';
import {Autocomplete, TextField} from '@mui/material';

import styles from 'assets/jss/FieldsStyle/InputsStyle';
import ArrowIcon from 'assets/img/autoCom_Arrow.svg';
import SelectFieldPaper from './SelectFieldPaper';

const useStyles = makeStyles(styles);

const AutoCompleteField = ({
                               options,
                               name,
                               values,
                               errors,
                               submitCount,
                               setFieldValue,
                               placeholder,
                               disabled,
                               fromEditProfile,
                                label
                           }) => {
    const classes = useStyles();

    const onChangeHandler = (_, value) => {
        if (name==='provinceId')
            if (values.provinceId?.id !== value?.id)
                setFieldValue('cityId','')
        setFieldValue(name, value);
    };


    return (
        <Autocomplete
            disableClearable
            name={name}
            value={values?.[name]??''}
            disabled={disabled}
            freeSolo
            options={options || []}
            onChange={(event, value) => onChangeHandler(event, value)}
            PaperComponent={SelectFieldPaper}
            popupIcon={fromEditProfile ? '' : <img src={ArrowIcon} alt='' className={classes.arrowStyle}/>}
            noOptionsText={
                <span className={classes.noItem}>
          {name === 'provinceId' ? 'استانی یافت نشد !' : 'شهری یافت نشد !'}
        </span>
            }
            getOptionLabel={(option) => option?.name??''}
            renderInput={(params) => (
                <div className={classes.parentTextField}>
                    {fromEditProfile &&
                        <div className={classes.textFieldMarker}>
                            {label??label}
                        </div>
                    }
                    <TextField
                        name={name}
                        {...params}
                        sx={{
                            '& .MuiInputBase-input::placeholder': {
                                color: '#707070',
                                opacity: 1,
                                fontWeight: 400,
                            },
                            '& input': {
                                textAlign: fromEditProfile ? 'left !important' : 'center !important',
                                ml: '0',
                            },
                        }}
                        fullWidth
                        className={[classes.textField, classes.inputBox]}
                        placeholder={fromEditProfile?'':placeholder}
                        error={!!submitCount && errors[name]}
                        helperText={
                            !!submitCount && (
                                <ErrorMessage
                                    name={name}
                                    render={(msg) => (
                                        <p className={classes.errMessage}>{msg}</p>
                                    )}
                                />
                            )
                        }
                    />
                </div>
            )}
        />
    );
};

export default AutoCompleteField;
